import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { Manifest } from 'services/action';
import { Skeletons } from 'ui/components/skeleton';

const initialState = {
  isShow: false,
  zoomImg: null,
  data: null,
  imgShow: 4,
};

export const ManifestDocument = ({ manifest_id, privilege }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Get.Image']
  );

  const dummy = Array.from({ length: 3 }, (v, i) => i);
  const [{ data, isShow, zoomImg, imgShow }, setState] =
    React.useState(initialState);

  const $onLoad = async (manifest_id) => {
    const res = await Dispatch(Manifest.$getByManifest(manifest_id));

    if (res?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: res?.data }));
    }
  };


  React.useEffect(() => {
    $onLoad(manifest_id);
  }, [manifest_id]);

  if (!data && !privilege) return null;

  return (
    <div className="">
      <div className="row">
        <div className="col-md-12 mb-3 mb-md-0">
          <div className="card legs rounded-2 bg-white">
            <div className="card-header-gray p-3 border-bottom">
              <h3 className="card-title dx-card-title m-0 p-0">
                Dokumentasi
              </h3>
            </div>
            <div className="card-body p-0 position-relative">
              {StateLoading ? (
                dummy?.map((d, i) => (
                  <div className="mb-3" key={i}>
                    <Skeletons height="30px" width="100%" />
                  </div>
                ))
              ) : !data? (
                <div className='cursor-pointer bg-white hr-text text-italic mt-4 mb-4'>
                  Data belum tersedia
                </div>
              ): (
                <div className='d-flex flex-wrap p-2 gap-2 align-items-center justify-content-center'>
                  {data?.slice(0, imgShow)?.map((d, i) => (
                    <div key={i} style={{ width: 80, height: 80 }}>
                      <img
                        className="img-hover medium rounded-3"
                        src={d?.image}
                        alt=""
                        onClick={() => {
                          setState((prevState) => ({
                            ...prevState,
                            isShow: true,
                            zoomImg: d,
                          }));
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({
            ...prevState,
            isShow: false,
          }))
        }
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                isShow: false,
              }))
            }
          />
          <div className="text-center mt-4">
            <img src={zoomImg?.image?.replace('_thumb', '')} alt="" />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
